import { React, useState, useEffect } from "react";
import axios from "axios"
import { useMyContext } from "../Provider/CommonProvider";
// import loadings from "../../../src/components/Images/loading/gif_loadings.gif";

function FetchLoader() {
    const { fetchRequest } = useMyContext()
    const [loginData, setLoginData] = useState(null);
    const loadingGifVideo_local = localStorage.getItem("loadingGifVideo");

    useEffect(() => {
        const userData = localStorage.getItem("access_token");
        setLoginData(userData);
    }, []);

    const [loadingGifVideo, setLoadingGifVideo] = useState(null);
    const access_token = localStorage.getItem("access_token");
    useEffect(() => {
        // Retrieve access token from local storage


        // Proceed only if access_token is available
        if (access_token) {
            const headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + access_token,
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
            };

            const fetchData = async () => {
                await fetchRequest({
                    method: 'GET',
                    url: `${process.env.REACT_APP_Baseurl}/admin/Site-ThemeSetting/index`,
                    params: {},
                    data: {},
                })
                    .then(response => {
                        const gifFile = response?.Site_theme_setting[0]?.loading_gif_video;
                        if (response?.status) {
                            setLoadingGifVideo(gifFile);
                        }
                    }).catch((error => {
                        console.error(error)
                    }))
            };

            // Fetch data from API
            fetchData();
        }
    }, [access_token]);

    return (
        <>
            {loginData === null ? (
                <div className="overlay-container">
                    <span className="overlay-icon">
                        <img src={loadingGifVideo_local} style={{ width: "80px", height: "80px", objectFit: "contain" }} alt="Animated GIF" />Processing ...
                    </span>
                </div>
            ) : (

                <div className="overlay-container">
                    <span className="overlay-icon">
                        <img src={loadingGifVideo} style={{ width: "80px", height: "80px", objectFit: "contain" }} alt="Animated GIF" />Processing ...
                    </span>
                </div>
            )}
        </>
    );
}

export default FetchLoader;
